var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardNavigation = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@wheelroom/core");

var navigation_segment_1 = require("../../navigation-segment/navigation-segment");

var get_nav_segments_1 = require("../get-nav-segments");

exports.CardNavigation = function (props) {
  if (props.hideCard) {
    return null;
  }

  var segments = get_nav_segments_1.getNavSegments(props.navigation, 'card');
  return react_1.default.createElement(core_1.Flex, {
    is: 'nav',
    wheel: props.wheel
  }, react_1.default.createElement(navigation_segment_1.NavigationSegment, {
    headingElementName: "h4",
    hideActionHeading: false,
    hideActionIcon: false,
    hideSegmentAbstract: false,
    hideSegmentHeading: false,
    maxSegments: props.maxSegments,
    navigationSegment: segments,
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.segment
    })
  }));
};